module.exports = __webpack_public_path__ + "img/san_fran_fisherman.d13b152d.jpg";